<template lang="pug">
  span(v-if="!isMgmt")
    button.btn.btn-default(v-if="icon === 'button'" :disabled="disabled" type="button" @click="onClick" title="お気に入り" data-testid="btn-func-favorite"): i.fa.fa-star
    a(v-else, href="#", @click.prevent="onClick" data-testid="icon-func-favorite")
      i.fa.fa-2x.text-yellow(:class="favorited ? 'fa-star' : 'fa-star-o'" :title="favorited ? 'お気に入りの解除' : 'お気に入りに登録'" data-testid="-icon")

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    //- 未選択
    app-modal(v-model="modalNoItem" type="info")
      template(slot="title") 未選択
      h4 名刺を1件以上選択してください。

    app-modal(v-model="modalError" type="warning")
      template(slot="title") エラー
      h4 お気に入り情報の変更に失敗しました。
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-default(type="button" @click="close()") 閉じる
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const FavoriteRepository = RepositoryFactory.get('favorite')

export default {
  name: 'FuncFavorite',
  components: { AppModal, AppMessages },
  props: {
    /**
     * checkedIds（複数のID指定の場合に使う）
     */
    checkedIds: { type: Array, required: false, default () { return [] } },
    /**
     * useSearch（全件選択の場合に使う）
     */
    useSearch: { type: Boolean, required: false, default: false },
    /**
     * conds（全件選択の場合に使う）
     *    - search_target（必須）
     */
    conds: { type: Object, required: false, default () { return {} } },
    // 単数の場合、名刺人物IDを使う
    sidPerson: { type: [String, Number], required: false, default: '' },
    // 単数の場合、現在のisFavoriteを指定する
    value: { type: String, required: false, default: '0' },
    icon: { type: String, required: false, default: 'button', validate (value) { return this.isIncludes(['button', 'icon'], value) } }
  },
  data () {
    return {
      message: '',
      favorited: false,
      modalNoItem: false,
      modalError: false
    }
  },
  computed: {
    disabled () {
      // 全ページ選択モードの時は利用しない（#730 通信が重くなるので）
      return this.$parent.isAllPagesChecked
    }
  },
  watch: {
    value (newval, oldval) {
      if (newval !== oldval) {
        this.syncFavorited(newval)
      }
    }
  },
  created () {
    this.syncFavorited(this.value)
  },
  methods: {
    syncFavorited (isFavorite) {
      this.favorited = isFavorite === this.app_flag.ON
      this.$forceUpdate()
    },
    onClick () {
      if (this.sidPerson || this.checkedIds.length) {
        this.submit()
      }
      else {
        this.modalNoItem = true
      }
    },
    submit () {
      // 単数
      if (this.sidPerson) {
        // お気に入り解除
        if (this.favorited) {
          this.submitUnfavorite()
        }
        // お気に入り登録
        else {
          this.submitFavorite()
        }
      }

      // 複数
      else {
        this.submitBulk()
      }
    },
    submitFavorite () {
      const vm = this
      FavoriteRepository.favorite(this.sidPerson)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.favorited = !vm.favorited
            vm.showToast('お気に入りに追加しました。', {type: 'success'})
            // 一覧更新
            vm.$store.dispatch('reloadBcardList')
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || 'お気に入りに追加できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    },
    submitUnfavorite () {
      const vm = this
      FavoriteRepository.unfavorite(this.sidPerson)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.favorited = !vm.favorited
            vm.showToast('お気に入りを解除しました。', {type: 'success'})
            // 一覧更新
            vm.$store.dispatch('reloadBcardList')
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || 'お気に入りを解除できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    },
    submitBulk () {
      // 全件検索用の条件と、ID指定用の条件をセット
      const conds = this.useSearch ? this.conds : null
      const sidBcards = this.useSearch ? null : this.checkedIds

      // 全件検索なのに検索条件がない場合
      if ((this.useSearch && !Object.keys(conds).length) ||
        // ID指定なのにIDが未選択の場合
        (!this.useSearch && !sidBcards.length)) {
        this.showToast('検索条件が正しく設定されていないため、お気に入り変更できません。', { type: 'danger' }) // system error
        return false
      }

      const vm = this
      FavoriteRepository.bulk(sidBcards, conds)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.showToast('お気に入り状態を変更しました。', {type: 'success'})
            // 一覧更新
            vm.$store.dispatch('reloadBcardList')
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || 'お気に入り状態を変更できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/functions/FuncFavorite.vue